import React, { useState } from 'react';
import Icon from '../../Components/Icons/Icon';
import { classNames } from '../../Services/helpers';
import { useScroll, scrollDirection } from '../../Components/Help';
import { useAssistantContext } from '../../Components/Assistant';
import Switcher from '../Switcher';
import { useSession } from '../../Components/Session';
import GlobalSearch from '../../Components/GlobalSearch';
import { levels } from '../../Data/Admin';
import { useNavigate } from 'react-router-dom';

const transition = 'transition-all duration-200';
const wrapperCompact = 'p-1';
const wrapperOpen = 'p-2 pb-1';

const NavRedesign = () => {
    const [compact, setCompact] = useState(false);
    const [switcherOpen, setSwitcherOpen] = useState(false);
    const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
    const {notificationBadge, isAdmin, isAdminSwitched, adminSwitchBack} = useSession();
    const navigate = useNavigate();

    useScroll((direction) => {
        setCompact(direction === scrollDirection.DOWN);
    });

    const handleClick = (e, handler) => {
        e.preventDefault();
        e.stopPropagation();

        if (compact) {
            setCompact(false);
        } else {
            handler();
        }
    }

    return <>
        <div className="fixed bottom-3 left-0 right-0 z-20 bg-transparent flex justify-center pointer-events-none">
            <div className={classNames(
                transition,
                'inline m-auto rounded-full',
                'bg-slate-50/50 dark:bg-slate-800/20 dark:text-slate-100 dark:fill-slate-100 backdrop-blur-md',
                'justify-between items-center',
                compact ? 'border border-white/50 dark:border-black/50' : 'border-3 border-white dark:border-black ring-1 ring-brand',
                compact ? 'shadow-sm' : 'shadow-xl',
                compact ? 'px-2' : 'px-5',
                compact ? 'mb-0' : 'mb-5'
            )}>
                <div className={classNames(
                    'flex items-center pointer-events-auto',
                    compact ? 'gap-1' : 'gap-2'
                )}>

                    <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen)}
                            onClick={(e) => handleClick(e, () => navigate('/'))}
                        >
                        <Icon icon="HouseChimney" size={compact ? '1x' : '2x'} badge={notificationBadge} className={transition} />
                    </div>
                    <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen)}
                            onClick={(e) => handleClick(e, () => setGlobalSearchOpen(!globalSearchOpen))}
                        >
                        <Icon icon="MagnifyingGlass" size={compact ? '1x' : '2x'} className={transition} />
                    </div>
                    <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen)}
                            onClick={(e) => handleClick(e, () => setSwitcherOpen(!switcherOpen))}
                        >
                        <Icon icon="GridRound2" size={compact ? '1x' : '2x'} className={transition} />
                    </div>
                    {isAdmin(levels.READ_ONLY) && <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen)}
                            onClick={(e) => handleClick(e, () => navigate('/admin'))}
                        >
                        <Icon icon="Wrench" size={compact ? '1x' : '2x'} className={transition} />
                    </div>}
                    {isAdminSwitched && <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen, 'fill-red-600')}
                            onClick={(e) => handleClick(e, () => adminSwitchBack())}
                        >
                        <Icon icon="ArrowLeftToBracket" size={compact ? '1x' : '2x'} className={transition} />
                    </div>}
                    <Assistant {...{compact}} />
                </div>
            </div>
        </div>
        <Switcher isOpen={switcherOpen} setIsOpen={() => setSwitcherOpen(false)} />
        <GlobalSearch isOpen={globalSearchOpen} setIsOpen={() => setGlobalSearchOpen(false)} />
    </>
}

const Assistant = ({ compact }) => {
    const { assistantOpen, setAssistantOpen, unseen} = useAssistantContext();
    const {showDarkMode} = useSession();

    return <div className={classNames(transition, compact ? wrapperCompact : wrapperOpen)}
            onClick={() => setAssistantOpen(!assistantOpen)}
        >
        <Icon icon={
                assistantOpen || unseen ? (showDarkMode ? "SidSolidDark" : "SidSolid") : (showDarkMode ? "SidLightDark" : "SidLight")
            }
            theme="soapy"
            size={compact ? '1x' : '2x'}
            className={transition}
        />
    </div>
}

export default NavRedesign;
